import { render, staticRenderFns } from "./TableInspectDouble.vue?vue&type=template&id=8facc920&scoped=true"
import script from "./TableInspectDouble.vue?vue&type=script&lang=js"
export * from "./TableInspectDouble.vue?vue&type=script&lang=js"
import style0 from "./TableInspectDouble.vue?vue&type=style&index=0&id=8facc920&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8facc920",
  null
  
)

export default component.exports